var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1246_14368",
    transform: "scale(0.0178571)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1246_14368",
    width: 56,
    height: 56,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4CAYAAACohjseAAAAAXNSR0IArs4c6QAABQVJREFUaIHtWmtsFFUU/s6d6RYKlKoBjBqoaSttt5o2UcAYFYyaYHhst9ZfJhqklkICaiBGExN+mJgQ4wNoV6RajL+09AU1MamPKv4gYCMgW7elgASNBoS2KaGyO3OPP+xj7nRb2svgsrhfMsmec0/Od7+ds/fOPTtACinc0KB4zjtW7srINKKLDDIWM/F0vdRiIEqxb3oaNv40UVThqu0lZJqPMjhLh4UZMQb9EGla/1288TECC4K1CwixVgKKdAjjULw35+KfW9rbt1pOb3n550bYuvAhEdZ4w4MTEmlP/NK49ozTKZSQrVsFIdbmnTgA4JfO3TL3Dbc3LC++5aE4AMgzEGt1OxWB/qPzlhKQ5yHpvyDalLt8e+aw+dCqj2YR8wavaRgoyg/sWOr0mUoA8RJyVK24wjk/f7H+lA5ZUVnNFmbaBgAEzJ6ebuYB6ACAAd+VYkjKGAkmvBhuqNqtw7OwfPfdpm2NzNEgYzGA9hENajj7nJauOACATYedZgz2rOHP0iJDCbWtE7o0XfUVp522e1F0Cbz5kBKY7EgJTHakBCY7UgKTHYkRyEbUaRIMraMSAOSX7rxNycUknbaJBIB9IgLbtob5haD3/aWhTZrpchRLmGGnmRCB4fq1F/2lNd+D6LEh13wQ5l97Zj4TFm3NTk/CfoMk+XkmPn31yEnmY+5F1FqN+nrb6U/IHQSA4y0bzt6z8u1FpjFjBRGeAUizNcKXIOiw1W9XR77eeME9mjCBANC9f/NfAPYMXdcF/69tgkFKY6g4UKe9fNtEaYqDDNbNdS1QSlRARIDRecTE34f8paHfp56WQCSLWW1/dLmjigN1WVEaXCMgljB4ztR5AAA2gIM2ozbSXPXr2JkohO9mRcW0CAHzNMnGw95wY1W501EQrF0gKPYVGLleEBBwXsBcdayx4qDTr5TokeaX+xgcAPicF6RDOCmRttntFGzVeSUOABiYY8Nqvqv8HWU1jtvZzg+Esg1Bz4J5GUBaCxEB5yXhgG2l7ena98KAcyz7qerbZ0wTf4zGch+zOKLDA+JsANkjtsTT4eaqhmEz7jYxVMtvDl2eY1Z62kKJ0f04Bg52Na37VidXYXn1TLLF6BcoUAigYdRMAJhtpXJISu0VtrN+wyUlN6TSkrzp98G4JZofCGULgeeIcT+AmZq5B0HUaln9n3bte3Xg6uHXB2MEFpbtWkxsfQmIrPhL0FTAyw0zc0tucPfDPY0Vv11rNh0oJVocqMsitj8DhPYTjBsEZKez9YlX+aYK5Q7GxJXHAVow4mCcBeikTmImziPgTgAA4ZH7SkNzjzVVebm/TgpqibIsBI3WpY3ekkjT62OOIJPBvWU1AcnUNMwjDZkL4D8XqD5sEyu2rjgAYJv6nLZlSd94sdcTN/02kRKY7EgJTHakBCY7UgKTHYpAYhp02gUrPtB+64kJJQoR+UZakhZYOT6ZZDygy1NQ5p4jKf9cudqG5kFnK0H4uNsfDOlyOzjRa1t9R4fNaJrRkyFlPzNmAwATbfMHQ9u0crOrGWDjgNNU7qDP4sME7tAimmgOkmqdh95T9ZX9DPGx1zxg6u5sWT++wI79lZdtyDJm7vaQdqffvPU1tzPcUPkKCdrhIc+Pkswn3c5xz+z+4K5lDPtB9/trk4Ugo5cttIVb1nVOFFcU2J4jybcaZGdOFDceCOIySRw63lzVfvXoFFK44fAPetOmglLKuq4AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.ae231dae435a37cab8293356c323b77f.svg";
export { ForwardRef as ReactComponent };